import { Competition_entry } from './competition_entry';

export class Section_entry extends Competition_entry {
	is_section_entry: boolean = true;

	constructor(values: Object = {}) {
		super(values);
		Object.assign(this, values);
	}

}